export default __webpack_public_path__ + "static/media/287.2256c28a.png";